import { render, staticRenderFns } from "./NotServerAccess.vue?vue&type=template&id=11b1de62"
import script from "./NotServerAccess.vue?vue&type=script&lang=js"
export * from "./NotServerAccess.vue?vue&type=script&lang=js"
import style0 from "./NotServerAccess.vue?vue&type=style&index=0&id=11b1de62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports